module.exports = "<div class=\"col-xs-10 prod-pic-col\">\r\n    <img src=\"assets/images/product-photo.jpg\" class=\"img-responsive\">\r\n</div>"